import genericStore from "../generic_store";
import axios from "axios";
import { config } from "@/config/constants.js";

export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "report_pictures",
    object: "report_picture",
    header: [
      { text: "Usuario", value: "user_id" },
      { text: "Imagen Reportada", value: "picture_id" },
      { text: "Motivo", value: "reason" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    roles: [],
    options: {
      sortBy: ["_id"],
      sortDesc: [true],
    },
  },
  mutations: {
    ...genericStore.mutations,
  },
  actions: {
    ...genericStore.actions,
    getPictures({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");
        let filter = {
          ...options
          /* search: ""*/
        };
        axios
          .get(config.api_url.replace('/admin/','/') + "user/work_picture", {
            params: filter
          })
          .then(response => {
            commit("success", {
              list_: response.data,
              total_: parseInt(
                response.headers["pagination-count"]
              )
            });
            resolve(response.data);
          })
          .catch(err => {
            commit("error");
            reject(err);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
